jQuery(function () {

    var helpButton = jQuery('#insurance-help--submit');

    if (helpButton.length > 0) {

        helpButton.on('click', function (event) {
            event.preventDefault();
            var form = helpButton.parents('form');
            var select = form.find('select');

            if (select.val()) {
                window.location.href = select.val();
            } else {
                return false;
            }

        });
    }


});